import { TCustomRouteObject } from '@/shared/types/router.types';

export const errorRoutes: TCustomRouteObject = {
  path: '*',
  lazy: async () => {
    const { NotFoundRoute } = await import('./not-found');
    return { Component: NotFoundRoute };
  },
};
